import React, { useState, useEffect } from "react";
import { showErrorToast } from "../../services/toastService.js";
import RTEditor from "../richText/RTEditor.jsx";
import { getAllMapIcons } from "../../services/mapIconService.js";
import { useSensorsMap } from "../../contexts/SensorsMapProvider.jsx";

export default function AddPinModal({ pin, onSave, onCancel }) {
	const [title, setTitle] = useState("");
	const [iconId, setIconId] = useState(18);
	const [html, setHtml] = useState(null);
	const [latitude, setLatitude] = useState("");
	const [longitude, setLongitude] = useState("");
	const [isPublic, setIsPublic] = useState(true);
	const [icons, setIcons] = useState([]);
	const [iconsGroups, setIconsGroups] = useState([]);
	const [selectedIcon, setSelectedIcon] = useState(null);
	const { dispatch, ACTIONS } = useSensorsMap();

	useEffect(() => {
		const selected = icons.find((icon) => icon.id === parseInt(iconId));
		setSelectedIcon(selected);
	}, [iconId, icons]);

	useEffect(() => {
		getAllMapIcons().then((res) => {
			setIcons(res.data.icons);
			setIconsGroups(res.data.groups);
		});
	}, []);

	useEffect(() => {
		if (pin) {
			setTitle(pin.title || "");
			setIconId(pin.icon_id || 18);
			setHtml(pin.html);
			setLatitude(pin.lat || "");
			setLongitude(pin.lon || "");
			setIsPublic(pin.public ?? true);
		}
	}, [pin]);

	const handleSave = () => {
		if (!title.trim() || !latitude || !longitude) {
			showErrorToast("Titolo e coordinate sono obbligatori.");
			return;
		}
		dispatch({ type: ACTIONS.SELECT_GROUP, payload: selectedIcon?.icon_group });

		onSave({
			...pin,
			title,
			icon: iconId,
			icon_size: selectedIcon?.size,
			icon_anchor: selectedIcon?.anchor,
			icon_path: selectedIcon?.path,
			icon_name: selectedIcon?.name,
			icon_label: selectedIcon?.label,
			icon_group_id: selectedIcon?.icon_group,
			html: html,
			lat: parseFloat(latitude),
			lon: parseFloat(longitude),
			public: isPublic,
		});
	};

	return (
		<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
			<div className="bg-white rounded-lg shadow-lg p-6 w-[800px] space-y-6">
				<h2 className="text-lg font-bold text-center">
					{pin ? "Modifica Pin" : "Aggiungi un Pin"}
				</h2>
				{/* Campo Titolo e Tipo */}
				<div className="grid grid-cols-2 gap-4">
					<div>
						<label className="block text-gray-700 text-sm font-bold mb-2">Titolo</label>
						<input
							type="text"
							value={title}
							onChange={(e) => setTitle(e.target.value)}
							className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
							placeholder="Inserisci il titolo del pin"
						/>
					</div>

					<div>
						<label className="block text-gray-700 text-sm font-bold mb-2">
							Tipo di Icona
						</label>
						<div className="flex items-center gap-4">
							<div className="flex-shrink-0">
								{selectedIcon && (
									<img
										src={selectedIcon.path}
										alt={selectedIcon.label}
										className="h-12 w-12"
									/>
								)}
							</div>
							<select
								value={iconId}
								onChange={(e) => setIconId(e.target.value)}
								className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
							>
								{iconsGroups.map((group) => (
									<optgroup key={group.id} label={group.label}>
										{icons
											.filter((icon) => icon.icon_group === group.id)
											.map((icon) => (
												<option key={icon.id} value={icon.id}>
													{icon.label}
												</option>
											))}
									</optgroup>
								))}
							</select>
						</div>
					</div>
				</div>
				{/* Input per le Coordinate */}
				<div className="grid grid-cols-2 gap-4">
					<div>
						<label className="block text-gray-700 text-sm font-bold mb-2">
							Latitudine
						</label>
						<input
							type="number"
							step="any"
							value={latitude}
							onChange={(e) => setLatitude(e.target.value)}
							className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
							placeholder="Inserisci la latitudine"
						/>
					</div>
					<div>
						<label className="block text-gray-700 text-sm font-bold mb-2">
							Longitudine
						</label>
						<input
							type="number"
							step="any"
							value={longitude}
							onChange={(e) => setLongitude(e.target.value)}
							className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
							placeholder="Inserisci la longitudine"
						/>
					</div>
				</div>
				{/* Checkbox per Public */}
				<div className="flex items-center gap-2">
					<input
						type="checkbox"
						checked={isPublic}
						onChange={(e) => setIsPublic(e.target.checked)}
						className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
					/>
					<label className="text-gray-700 text-sm font-bold">
						Rendi pubblico questo pin
					</label>
				</div>
				{/* Editor HTML */}
				<div>
					<label className="block text-gray-700 text-sm font-bold mb-2">
						Descrizione
					</label>
					<RTEditor html={html} setHtml={setHtml} />
				</div>
				{/* Pulsanti */}
				<div className="flex justify-end space-x-4 mt-6 pt-5">
					<button
						id="ignore"
						aria-label="Annulla"
						className="bg-gray-300 text-gray-700 py-2 px-4 rounded hover:bg-gray-400 transition"
						onClick={onCancel}
					>
						Annulla
					</button>
					<button
						id="save"
						aria-label="Salva"
						className="bg-blue-700 text-white py-2 px-4 rounded hover:bg-blue-800 transition"
						onClick={handleSave}
					>
						Salva
					</button>
				</div>
			</div>
		</div>
	);
}
